module.exports = new __parcel__URL__("lexus-white-with-tagline.d873410e.svg").toString();